import React, {FC, createContext, useContext} from 'react'
import { WithChildren } from '../../../_metronic/helpers'
import enMessages from './messages/en.json'
import esMessages from './messages/es.json'
import { IntlProvider } from 'react-intl'
import { environment } from '../../util/Environment'

const I18N_KEY = environment.localStorage.i18nKey

const allMessages = {
  en: enMessages,
  es: esMessages,
}

type Props = {
  selectedLang: string
}

const initialState: Props = {
  selectedLang: environment.i18n.default,
}

function getConfig(): Props {
  const ls = localStorage.getItem(I18N_KEY)
  if (ls) {
    try {
      return JSON.parse(ls) as Props
    } catch (er) {
      console.error(er)
    }
  }
  return initialState
}

// Side effect
function setLanguage(lang: string) {
  localStorage.setItem(I18N_KEY, JSON.stringify({selectedLang: lang}))
  window.location.reload()
}

const I18nContext = createContext<Props>(initialState)

const useLanguage = () => {
  return useContext(I18nContext).selectedLang
}

const I18nProvider: FC<WithChildren> = ({children}) => {
  const lang = getConfig()
  return <I18nContext.Provider value={lang}>{children}</I18nContext.Provider>
}

const LocaleProvider: FC<WithChildren> = ({children}) => {
  const locale = useLanguage()
  const messages = allMessages[locale]

  return (
    <IntlProvider locale={locale} messages={messages}>
      {children}
    </IntlProvider>
  )
}

export {I18nProvider, LocaleProvider, setLanguage, useLanguage}
